module.exports = __webpack_public_path__ + "static/media/custome-column-4.bbdecc8f.jpg";